"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnknownError = void 0;
const commons_objects_1 = require("@deliverr/commons-objects");
const getUnknownError = (err) => {
    return new commons_objects_1.DeliverrError({
        code: commons_objects_1.ApiError.UNKNOWN_ERROR,
        payload: err,
    });
};
exports.getUnknownError = getUnknownError;
//# sourceMappingURL=getUnknownError.js.map